<template>
  <div class="currency-input">
    <b-col :sm="size" class="input-group bill-field">
      <div class="input-group-prepend">
        <span class="input-group-text">
          {{ currencySymbol ? currencySymbol : getVendor.local_currency }}
        </span>
      </div>

      <b-form-input
        v-model="value"
        class="form-control currency"
        type="text"
        min="0"
        placeholder="0"
        required
        :value="amountDisplay"
        :title="name"
        :disabled="disabled"
        :state="fieldState"
        @keydown.native="keymonitor"
        @change="updateAmount"
      />
    </b-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CurrencyInput',
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    amount: {
      type: [String, Number],
      required: true,
      default: 0
    },
    size: {
      type: Number,
      required: false,
      default: 8
    },
    currencySymbol: {
      type: String,
      required: false,
      default: '$'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldState: {
      validator: prop => typeof prop === 'boolean' || prop === null,
      required: true,
      default: null
    }
  },
  data() {
    return {
      value: this.amount,
      validity: this.fieldState,
    }
  },

  computed: {
    ...mapGetters([
      'getVendor'
    ]),

    amountDisplay() {
      return !!this.amount
        ? parseFloat(this.amount).toFixed(2)
        : null
    }
  },

  methods: {
    keymonitor(keypress) {
      const validKeys = ['Tab', 'Backspace', 'Meta', 'Shift', 'Alt', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight' ]
      if (validKeys.indexOf(keypress.key) !== -1) return;

      if (keypress.key.match(/([^0-9\.])/g, '')) keypress.preventDefault();
    },

    updateAmount(amount) {
      if (parseFloat(amount) > 0) {
        this.validity = true;
        this.$emit('update:fieldState', this.validity);
      }
      let amountDisplay = amount;

      if (amount.replace) {
        amountDisplay = amount.replace(/\.+$/, '');
        if (!+amountDisplay) amountDisplay = 0;
      }

      this.value = parseFloat(amountDisplay).toFixed(2);
      this.$emit('update:amount', parseFloat(this.value));
    }
  },

  watch: {
    amount: function() {
      this.updateAmount(this.amount)
    }
  },
}
</script>
